"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _zh_CN = _interopRequireDefault(require("antd/lib/locale-provider/zh_CN"));
var _a, _b;
if (!_zh_CN["default"].TreeSelect) {
  _zh_CN["default"].TreeSelect = {
    searchPlaceholder: '搜索'
  };
}
_zh_CN["default"].TreeSelect = (0, _extends2["default"])((0, _extends2["default"])({}, _zh_CN["default"].TreeSelect), {
  all: '全部'
});
if (!_zh_CN["default"].Select) {
  _zh_CN["default"].Select = {};
}
_zh_CN["default"].Select = (0, _extends2["default"])((0, _extends2["default"])({}, _zh_CN["default"].Select), {
  all: '全部',
  searchPlaceholder: '搜索'
});
_zh_CN["default"].LocaleEditor = {
  title: '国际化',
  iconTips: '支持国际化',
  unset: '未设置',
  set: '已设置',
  label: {
    'zh-CN': '中文(zh-CN)',
    'en-US': '英语(en-US)',
    'de-DE': '德语(de-DE)'
  }
};
_zh_CN["default"].Table = (0, _extends2["default"])((0, _extends2["default"])({}, _zh_CN["default"].Table), {
  hasSelected: '已选择',
  columnsTitle: '编辑列',
  save: '保存',
  cancel: '取消',
  resetColumnsModalTitle: '确认恢复默认视图？',
  resetColumnsModalContent: '恢复后，所有自定义配置将无法找回。'
});
_zh_CN["default"].Pagination = (0, _extends2["default"])((0, _extends2["default"])({}, _zh_CN["default"].Pagination), {
  items_per_page: '/ 页'
});
_zh_CN["default"].DatePicker = (0, _extends2["default"])((0, _extends2["default"])((0, _extends2["default"])({}, _zh_CN["default"].DatePicker), {
  lang: (0, _extends2["default"])((0, _extends2["default"])({}, ((_a = _zh_CN["default"].DatePicker) === null || _a === void 0 ? void 0 : _a.lang) || {}), {
    placeholder: '日期',
    yearPlaceholder: '年份',
    quarterPlaceholder: '季度',
    monthPlaceholder: '月份',
    weekPlaceholder: '周'
  }),
  timePickerLocale: (0, _extends2["default"])((0, _extends2["default"])({}, ((_b = _zh_CN["default"].DatePicker) === null || _b === void 0 ? void 0 : _b.timePickerLocale) || {}), {
    placeholder: '时间'
  })
}), {
  rangeTimePlaceholder: ['开始时间', '结束时间']
});
var _default = exports["default"] = _zh_CN["default"];